import {useEffect, useRef} from 'react';
import PrimaryButton from "../components/base/Button";
import video from '../media/video/JigSawHeroFootage.mp4'
import {numberWithCommas} from "../utils/formatters";
import {ReactComponent as SherlockIcon } from "../components/icons/partners/sherlock.svg";
import {ReactComponent as SpearbitIcon} from "../components/icons/partners/spearbit.svg";

export const Hero = ({tvl}) => {
    const heroRef = useRef(null);
    const videoRef = useRef(null);

    const minTvl = 1000000

    useEffect(() => {
        const onScroll = () => {
            if (heroRef.current) {
                heroRef.current.style.transform = `translateY(-${window.scrollY * 0.5}px)`;
            }
        };

        window.addEventListener('scroll', onScroll);

        // Try to play the video after the component mounts
        if (videoRef.current) {
            videoRef.current.play().catch(error => {
                // Auto-play was prevented
                // Show a UI element to let the user manually start playback
            });
        }

        // Cleanup on unmount
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    return (
        <div ref={heroRef} className="sticky top-0 flex flex-col justify-center text-center h-screen">
            <video ref={videoRef} src={video} autoPlay muted loop playsInline id="video" preload="none"
                   className='absolute -z-10 w-full h-full object-cover'/>
            <div className='mx-auto flex flex-col max-w-xl items-center gap-8 max-md:mx-6'>
                <h1>Bringing fluidity to your collateral</h1>
                <p className="mx-auto max-w-lg text-center drop-shadow-md">
                    Keep full control of your funds while enjoying unparalleled flexibility and seamless
                    interoperability.
                </p>
                <div className="relative flex flex-col justify-center items-center gap-x-4 text-white">
                    <a href='https://app.jigsaw.finance/' target="_blank" rel='noreferrer'>
                        <PrimaryButton className='px-10' label="Get Started"> </PrimaryButton>
                    </a>
                    <div className='flex items-center mt-8 h-4'>
                        <i className='text-[10px] text-white/70'>Secured by</i>
                        <SpearbitIcon className='text-white h-5' alt='spearbit icon'/>
                        <SherlockIcon className='text-white h-2.5 w-28' alt='sherlock icon'/>
                    </div>
                    <div className='absolute flex flex-col gap-5 items-center -bottom-40'>
                        {tvl >= minTvl &&
                            <>
                                <p className='text-white/70'>Total Value Locked</p>
                                <span className='text-3xl leading-4'>${numberWithCommas(tvl)}</span>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero
